

const useStyles = () => {
  return {
      container:'w-full h-full  md:px-52 px-5  flex flex-col justify-center pt-8  backdrop-blur-sm text-white',
      textContainer:" h-full text-lg pt-14",
      skills:'text-4xl font-bold inline border-b-4 border-white ',
      text:'py-4',
      containerSkills:'w-full grid grid-cols-2 sm:grid-cols-5 gap-4 text-center pb-8  ',
      iconBox:'shadow-md shadow-[#040c16] rounded-full  p-2 flex items-center justify-center bg-black/40',
      icon:'w-20  mx-auto',
      containerCertif:'w-full md:flex grid gap-4 text-center py-8 ',
      certifBox:'shadow-md shadow-[#040c16]  rounded-md py-2 md:w-1/2 bg-black/40',
      certif:'w-full mx-auto p-3',
      
  }
}

export default useStyles